<template>
  <div
    class="bg-white rounded-xl shadow-sm border border-slate-200 overflow-hidden mb-3"
  >
    <div
      class="border-b border-gray-50 flex items-center justify-start bg-gray-50/20 flex items-center gap-1 px-3 py-3 border-b border-gray-100 bg-gray-50/50 flex items-center gap-1 w-full"
    >
      <div
        class="w-8 h-8 rounded bg-blue-50 flex items-center justify-center text-blue-600"
      >
        <i class="fa-solid fa-rectangle-list text-sm"></i>
      </div>
      <h3 class="text-xs font-bold text-slate-700 uppercase tracking-wider">
        {{ title ?? "Summary" }}
      </h3>
    </div>

    <div v-if="dataLoaded" class="p-6 flex flex-wrap gap-4">
      <div
        v-for="(info, index) in cardsInfo"
        :key="index"
        class="min-w-[220px] flex-1 group"
      >
        <div
          class="relative p-3 rounded-xl border border-slate-200 bg-white transition-all duration-200 hover:border-blue-300 hover:shadow-md hover:shadow-blue-500/5"
        >
          <div class="flex items-center gap-4">
            <div
              :class="[
                'w-12 h-12 rounded-full flex items-center justify-center text-xl shrink-0 transition-colors',
                info.type === 'primary'
                  ? 'bg-blue-50 text-blue-600'
                  : info.type === 'success'
                  ? 'bg-emerald-50 text-emerald-600'
                  : info.type === 'warning'
                  ? 'bg-amber-50 text-amber-600'
                  : 'bg-slate-100 text-slate-500',
              ]"
            >
              <i :class="info.icon"></i>
            </div>

            <div class="flex flex-col">
              <span
                class="text-[10px] font-bold text-slate-400 uppercase tracking-widest"
              >
                {{ info.label }}
              </span>
              <span class="text-2xl font-bold text-slate-800 leading-tight">
                {{ info.value }}
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div v-else class="p-16 flex flex-col items-center justify-center bg-white">
      <Loader />
      <span
        class="mt-4 text-[10px] font-semibold text-slate-500 uppercase tracking-widest animate-pulse"
      >
        Loading Summary...
      </span>
    </div>
  </div>
</template>

<script>
import Loader from "../Loader.vue";

export default {
  name: "SummaryCard",
  components: { Loader },
  props: {
    title: {
      type: String,
      default: "Summary",
    },
    cardsInfo: {
      type: Array,
      required: true,
    },
    dataLoaded: {
      type: Boolean,
      default: true,
    },
  },
};
</script>

